<template>
    <b-tab :title="langTabTitle">
        <b-card class="mb-3" no-body>
            <div class="card-header bg-primary-dark">
                <h2 class="card-title">
                    <span key="lang_source_songs">Playback Order</span>
                </h2>
            </div>
            <b-card-body>
                <b-form-group>
                    <b-row>
                        <b-form-group class="col-md-12" label-for="edit_form_order">

                            <b-form-radio-group stacked id="edit_form_order" v-model="form.playback_order.$model">
                                <b-form-radio value="shuffle">
                                    <span key="lang_edit_form_order_shuffle">Shuffled</span>
                                    <small class="form-text mt-0" key="lang_edit_form_order_shuffle_info">The full playlist is shuffled and then played through in the shuffled order.</small>
                                </b-form-radio>
                                <b-form-radio value="random">
                                    <span key="lang_edit_form_order_random">Random</span>
                                    <small class="form-text mt-0" key="lang_edit_form_order_random_info">A completely random track is picked for playback every time the queue is populated.</small>
                                </b-form-radio>
                                <b-form-radio value="sequential">
                                    <span key="lang_edit_form_order_sequential">Sequential</span>
                                    <small class="form-text mt-0" key="lang_edit_form_order_sequential_info">The order of the playlist is manually specified and followed by the AutoDJ.</small>
                                </b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>

                        <!-- <b-form-group class="col-md-6" label-for="form_edit_include_in_requests">
                            <template v-slot:description>
                                <span key="lang_form_edit_include_in_requests_desc">If requests are enabled for your station, users will be able to request media that is on this playlist.</span>
                            </template>
                            <b-form-checkbox id="form_edit_include_in_requests" v-model="form.include_in_requests.$model">
                                <span key="lang_form_edit_include_in_requests">Allow Requests from This Playlist</span>
                            </b-form-checkbox>
                        </b-form-group> -->

                        <b-form-group class="col-md-6" label-for="form_edit_is_jingle">
                            <template v-slot:description>
                                <span key="lang_form_edit_is_jingle_desc">Enable this setting will not display the track info. This is useful if the playlist contains jingles or bumpers.</span>
                            </template>
                            <b-form-checkbox id="form_edit_is_jingle" v-model="form.is_jingle.$model">
                                <span key="lang_form_edit_is_jingle">Hide Metadata from Listeners ("Jingle Mode")</span>
                            </b-form-checkbox>
                        </b-form-group>

                    </b-row>
                </b-form-group>
            </b-card-body>
        </b-card>

      
    </b-tab>
</template>

<script>
export default {
    name: 'PlaylistEditSource',
    props: {
        form: Object
    },
    computed: {
        langTabTitle () {
            return 'Source';
        }
    }
};
</script>